import Vue from 'vue'
import Router from 'vue-router'
import Header from '@/components/header'
import Footer from '@/components/footer'
import Index from '@/views/index'
import IotManage from '@/views/iotManage'
import IotIndex from '@/views/iotIndex'
import Iotdetail1 from '@/views/iotdetail1'
import Iotdetail2 from '@/views/iotdetail2'
import Iotdetail3 from '@/views/iotdetail3'
import Iotdetail4 from '@/views/iotdetail4'
import Iotdetail5 from '@/views/iotdetail5'
import Aboutus from '@/views/aboutus'
import Products from '@/views/products'
import prodetail from '@/views/prodetail'
import proNav from '@/views/proNav'
import Cases from '@/views/cases'
import casesNav from '@/views/casesNav'
import casedetail from '@/views/casedetail'
import Custom from '@/views/custom'
import Contact from '@/views/contactus'
import Account from '@/views/account'
import Register from '@/views/register'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
			meta: {
				commpage: true
			}
    },
    {
      path: '/header',
      name: 'Header',
      component: Header,
			meta: {
				commpage: true
			}
    },
    {
      path: '/footer',
      name: 'Footer',
      component: Footer,
			meta: {
				commpage: true
			}
    },
    {
      path: '/iotManage',
      name: 'IotManage',
      component: IotManage,
			meta: {
				commpage: true
			},
			children: [
				{
					path: '',
					name: 'IotIndex',
					component: IotIndex,
					meta: {
						commpage: true
					}
				},
				{
					path: 'iotdetail1',
					name: 'Iotdetail1',
					component: Iotdetail1,
					meta: {
						commpage: true
					}
				},
				{
					path: 'iotdetail2',
					name: 'Iotdetail2',
					component: Iotdetail2,
					meta: {
						commpage: true
					}
				},
				{
					path: 'iotdetail3',
					name: 'Iotdetail3',
					component: Iotdetail3,
					meta: {
						commpage: true
					}
				},
				{
					path: 'iotdetail4',
					name: 'Iotdetail4',
					component: Iotdetail4,
					meta: {
						commpage: true
					}
				},
				{
					path: 'iotdetail5',
					name: 'Iotdetail5',
					component: Iotdetail5,
					meta: {
						commpage: true
					}
				}
			]
    },
		{
			path: '/aboutus',
			name: 'Aboutus',
			component: Aboutus,
			meta: {
				commpage: true
			}
		},
		{
			path: '/products',
			name: 'Products',
			component: Products,
			meta: {
				commpage: true
			},
			children: [
				{
					path: '',
					name: 'proNav',
					component: proNav,
					meta: {
						commpage: true
					}
				},
				{
					path: 'prodetail',
					name: 'prodetail',
					component: prodetail,
					meta: {
						commpage: true
					}
				}
			]
		},
		{
			path: '/cases',
			name: 'Cases',
			component: Cases,
			meta: {
				commpage: true
			},
			children: [
				{
					path: '',
					name: 'casesNav',
					component: casesNav,
					meta: {
						commpage: true
					}
				},
				{
					path: 'casedetail',
					name: 'casedetail',
					component: casedetail,
					meta: {
						commpage: true
					}
				}
			]
		},
		{
			path: '/custom',
			name: 'Custom',
			component: Custom,
			meta: {
				commpage: true
			}
		},
		{
			path: '/contactus',
			name: 'Contact',
			component: Contact,
			meta: {
				commpage: true
			}
		},
		{
			path: '/account',
			name: 'Account',
			component: Account,
			meta: {
				commpage: false
			}
		},
		{
			path: '/register',
			name: 'Register',
			component: Register,
			meta: {
				commpage: false
			}
		},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js